module.exports = __webpack_public_path__ + "static/img/top_channel.f2a70f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/top_channel.png
// module id = 6ItA
// module chunks = 1